import request from '@/utils/request'
// 接听  /api/video/answer   naturalKey
export function getVideoAnswer(data) {
  return request({
    url: '/api/video/answer',
    method: 'post',
    data: data
  })
}

// /api/video/advice  分析
export function setVideoAdvice(data) {
  return request({
    url: '/api/video/advice',
    method: 'post',
    data: data
  })
}

// 查看视频详情 /api/video/get_video_detail
export function getVideoDetail(data) {
  return request({
    url: '/api/video/get_video_detail?naturalKey='+data,
    method: 'get'
  })
}

// 保存问诊记录
export function addConsultRecord(data) {
  return request({
    url: '/opm/consult/add_consult_record',
    method: 'post',
    data: data
  })
}
// 根据rxId查询就诊信息
export function selectRegistInfoDetailByRxId(data) {
  return request({
    url: '/flow/regist/select_regist_detail_by_rxId?rxId='+data,
    method: 'get'
  })
}
// 根据rxId查询就诊信息
export function getConsultInfoDetail(data) {
  return request({
    url: '/flow/regist/get_consult_info_detail?naturalKey='+data,
    method: 'get'
  })
}

// 结束问诊
export function finishRegistByRxId(data) {
  return request({
    url: '/flow/regist/finish_regist_by_rxId?rxId='+data,
    method: 'get'
  })
}





// WEBPACK FOOTER //
// ./src/api/center/video.js